<template>
  <div id="page">
    <van-nav-bar
      title="图片审核"
      left-text="关闭"
      left-arrow
      @click-left="onClickLeft"
    />
    <div align="center" style="margin-top: 48px;">
      <div>
        <img src="static/schmyshbank/img_order_result.png" width="96px" height="72px" />
      </div>
      <div style="margin-top: 8px;">
        <label>上传图片正在审核中</label>
      </div>
      <div style="margin-top: 8px;">
        <label>我们将在24小时内完成审核</label>
      </div>
      <div style="margin-top: 8px;">
        <label>此期间请不要申请新的卡片</label>
      </div>
      <div style="margin-top: 8px;">
        <label>否则将有可能导致此次申请开卡失败</label>
      </div>
    </div>
  </div>
</template>

<script>
  let msCallback = require('../../common/msCallback.js')
  export default {
    name: 'OrderResult_schmysh',
    data() {
      return {
        orderNo: ''
      }
    },
    mounted: function() {
      window.onCallBackKeydownback = msCallback.onCallBackKeydownback
    },
    methods:{
      onClickLeft: function() {
        console.log("-->", "closePage")
        msCallback.closePage()
      },
    }
  }
</script>

<style scoped>
  /* .van-nav-bar {
    background-color: whitesmoke
  }
  .van-nav-bar>>>.van-nav-bar__text {
    color: red;
  }

  .van-nav-bar>>>.van-nav-bar__title {
    color: black;
  }

  .van-nav-bar>>>.van-ellipsis {
    color: black;
  } */
</style>



// WEBPACK FOOTER //
// src/components/sichuanmianyangbank/OrderResult_schmysh.vue